import * as React from 'react'
import gql from 'graphql-tag'
import Link from 'next/link'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import {
  RecommendSearchKeywordType,
  useGqlEmptyCardQuery,
} from 'generated/graphql'

gql`
  query gqlEmptyCard($type: RecommendSearchKeywordType) {
    recommendSearchKeywordList(type: $type) {
      recommendSearchKeywords {
        id
        title
      }
    }
  }
`

const EmptyCard: React.FC = () => {
  const router = useRouter()
  const query = `${router.query.q || ``}`

  const { data } = useGqlEmptyCardQuery({
    variables: {
      type: RecommendSearchKeywordType.RECOMMEND_CHANNEL,
    },
  })

  return (
    <StyledWrapper>
      <div className="empty-title">
        <span>{query}</span> 검색 결과가 없습니다.
      </div>
      <div className="empty-subtitle">
        단어의 철자가 정확한지 확인하세요. <br />
        다른 검색어를 사용해보세요. <br />더 일반적인 검색어를 사용해보세요.
      </div>
      {data && data.recommendSearchKeywordList?.recommendSearchKeywords && (
        <div className="recommend-search-keyword">
          <div className="recommend-search-keyword-header">
            이런 검색어는 어떠세요?
          </div>
          <div className="recommend-search-keyword-list">
            {data.recommendSearchKeywordList.recommendSearchKeywords.map(
              (keyword) => (
                <Link
                  key={keyword?.id}
                  href={`/channel/search?q=${keyword?.title}`}
                >
                  <a>#{keyword?.title}</a>
                </Link>
              ),
            )}
          </div>
        </div>
      )}
    </StyledWrapper>
  )
}

export default EmptyCard

const StyledWrapper = styled.div`
  background-color: white;
  border: 1px solid #e8e8e8;
  padding: 72px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  .empty-title {
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 500;
    span {
      color: #01a0ff;
    }
  }
  .empty-subtitle {
    font-size: 16px;
    color: #999;
    margin-bottom: 64px;
  }
  .recommend-search-keyword {
    .recommend-search-keyword-header {
      font-size: 16px;
      margin-bottom: 12px;
    }
    .recommend-search-keyword-list {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      width: 340px;
      justify-content: center;
      a {
        color: #01a0ff;
      }
    }
  }
`
